<template>
<b-container class="">
  <b-row align-h="start">
  <h1>Data bit swapper</h1>
  </b-row>
  <b-row>
  <h2>Here paste the HEX</h2>
  </b-row>
  <b-row>
      <b-form-textarea id="textarea1"
                     v-model="text"
                     placeholder="Paste HEX, or drag text file here"
                     :rows="3"
                     :max-rows="6">
    </b-form-textarea>
    </b-row>

    <b-row>
      <h2>Data pin assignment</h2>
    </b-row>

    <b-row>
      <p>Select (E)EPROM data pin, assigned to given CPU data pins</p>
    </b-row>

    <b-row>
      <div class="col-2">
        <div class="text-warning" v-if="dinvalid">Invalid combination</div>
      </div>


      <div v-for="item in dassign" :key="item" style="width:8%">
        <b-input-group size="sm" :prepend="item.cpu">
          <b-form-select size="sm" v-model="item.rom" :options="datas" />
        </b-input-group>
      </div>


    </b-row>



    <b-row>
      <h2>Address pin assignment</h2>
    </b-row>

    <b-row>
      <p>Select (E)EPROM address pins, assigned to given CPU address pins</p>
    </b-row>


    <b-row>
      <div class="col-2">
        <div class="text-warning" v-if="ainvalid">Invalid combination</div>
      </div>
      <div v-for="item in ahassign" :key="item" style="width:8%">
        <b-input-group size="sm" :prepend="item.cpu">
          <b-form-select size="sm" v-model="item.rom" :options="adds" />
        </b-input-group>
      </div>


    </b-row>
    <b-row>
      <div class="col-2">
        <div class="text-warning" v-if="ainvalid">Invalid combination</div>
      </div>
      <div v-for="item in alassign" :key="item" style="width:8%">
        <b-input-group size="sm" :prepend="item.cpu">
          <b-form-select size="sm" v-model="item.rom" :options="adds" />
        </b-input-group>
      </div>


    </b-row>




  <b-row>
  <h2>Here is the output text</h2>
  </b-row>
    <b-row>
      <div class="sourceout">{{textout}}</div>
    <b-form-textarea id="textarea2"
                     readonly
                     v-model="textout"
                     :rows="10"
                     :max-rows="15">
    </b-form-textarea>
    </b-row>
</b-container>
</template>

<script>

//import hexinput from './visual/hexinput.vue'

var download = function (filename, arr, from, to) {
  var text = '';
  for (var i = from; i <= to; i++) {
    text += String.fromCharCode(arr[i]);
  }
  var pom = document.createElement('a');
  pom.setAttribute('href', 'data:application/octet-stream;base64,' + btoa(text));
  pom.setAttribute('download', filename);
  document.body.appendChild(pom);
  pom.click();
  document.body.removeChild(pom);
};

var doDrag = function (_this) {
  var holder = document.getElementById('textarea1')

  holder.ondragover = function () {
    this.className = 'form-control';
    return false;
  };
  holder.onmouseleave = function () {
    this.className = 'form-control';
    return false;
  };
  holder.ondrop = function (e) {
    this.className = 'form-control';
    e.preventDefault();

    var file = e.dataTransfer.files[0]
    var reader = new FileReader();
    reader.onload = function (event) {
      _this.text = event.target.result;
    };
    reader.readAsText(file);

    return false;
  };
}

var hexLine = function (ln) {
  let out = {}
  if (ln[0] !== ':') return false;
  var len = parseInt(ln[1] + ln[2], 16);
  var start = parseInt(ln[3] + ln[4] + ln[5] + ln[6], 16);
  var typ = parseInt(ln[7] + ln[8], 16);
  out.len = len
  out.start = start
  out.typ = typ
  if (typ === 0) {
    out.data = [];
    for (let i = 0; i < len; i++) {
      out.data[i] = parseInt(ln[9 + 2 * i] + ln[10 + 2 * i], 16);
    }
  }
  return out;
}

var hex2 = function (n) {
  var out = n.toString(16).toUpperCase();
  while (out.length < 2) out = '0' + out
  return out
}

var hex4 = function (n) {
  var out = n.toString(16).toUpperCase();
  while (out.length < 4) out = '0' + out
  return out
}

var genHex = function (h) {
  let out = ':';
  out += hex2(h.len);
  out += hex4(h.start);
  out += hex2(h.typ);
  let crc = h.len + h.typ + (h.start >> 8) + (h.start & 0xff);
  if (h.typ === 0) {
    for (let i = 0; i < h.len; i++) {
      out += hex2(h.data[i])
      crc += h.data[i];
    }
  }
  crc = crc & 0xff
  out += hex2(256 - crc);
  return out;
}

var scramble = function (n, dass) {
  var bits = [];
  for (let i = 0; i < 8; i++) {
    bits[i] = n & 1
    n >>= 1
  }

  var out = 0;

  for (let i = 0; i < 8; i++) {
    out <<= 1
    out += bits[dass[i]];
  }

  return out
}

/*
var pad = function (data, mode, len = 2) {
  if (mode === 'dec') return data;
  let n = data.toString(16).toUpperCase();
  while (n.length < len) n = '0' + n;
  if (mode === 'hex') return '$' + n
  if (mode === '0x') return '0x' + n
  if (mode === 'xxx') return n
}
*/
export default {
  name: 'bitswap',
  //components: {hexinput},
  data () {
    return {
      dassign: [
        {cpu: 'D7', rom: 'D7'},
        {cpu: 'D6', rom: 'D6'},
        {cpu: 'D5', rom: 'D5'},
        {cpu: 'D4', rom: 'D4'},
        {cpu: 'D3', rom: 'D3'},
        {cpu: 'D2', rom: 'D2'},
        {cpu: 'D1', rom: 'D1'},
        {cpu: 'D0', rom: 'D0'}
      ],
      ahassign: [
        {cpu: 'A15', rom: 'A15'},
        {cpu: 'A14', rom: 'A14'},
        {cpu: 'A13', rom: 'A13'},
        {cpu: 'A12', rom: 'A12'},
        {cpu: 'A11', rom: 'A11'},
        {cpu: 'A10', rom: 'A10'},
        {cpu: 'A9', rom: 'A9'},
        {cpu: 'A8', rom: 'A8'}
      ],
      alassign: [
        {cpu: 'A7', rom: 'A7'},
        {cpu: 'A6', rom: 'A6'},
        {cpu: 'A5', rom: 'A5'},
        {cpu: 'A4', rom: 'A4'},
        {cpu: 'A3', rom: 'A3'},
        {cpu: 'A2', rom: 'A2'},
        {cpu: 'A1', rom: 'A1'},
        {cpu: 'A0', rom: 'A0'}
      ],
      datas: ['D0', 'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'D7'],
      adds: ['A0', 'A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'A9', 'A10', 'A11', 'A12', 'A13', 'A14', 'A15'],
      text: '',
      fname: 'convert',
      mFrom: 0,
      mTo: 65535,
      memory: []
    }
  },
  watch: {
    text (/*val*/) {
      // had to parse!
      // console.log(val)
      var ln = this.text.split('\n');
      this.memory = [];
      this.memory[65535] = 0;
      var amin = 65535;
      var amax = 0;
      for (let i = 0; i < ln.length; i++) {
        let hl = hexLine(ln[i]);
        if (!hl) continue;
        if (hl.len === 0) continue;
        if (amin > hl.start) amin = hl.start;
        if (amax < (hl.start + hl.len)) amax = hl.start + hl.len;
        for (let j = 0; j < hl.len; j++) {
          this.memory[hl.start + j] = hl.data[j]
        }
      }
      if (amin > amax) {
        this.mFrom = amax;
        this.mTo = amin;
      } else {
        this.mFrom = amin;
        this.mTo = amax;
      }
    }
  },
  methods: {
    clearMemory () {
      this.memory = [];
      this.memory[65535] = 0;
      this.mFrom = 0;
      this.mTo = 65535;
      this.text = '';
    },
    dl () {
      download(this.fname + '.bin', this.memory, this.mFrom, this.mTo)
    }
  },
  computed: {
    dinvalid: function () {
      var out = ['D0', 'D1', 'D2', 'D3', 'D4', 'D5', 'D6', 'D7'];
      // console.log(this.dassign[0].rom, out)
      for (var i = 0; i < 8; i++) {
        let d = this.dassign[i].rom;
        let q = out.indexOf(d)
        if (q < 0) return true;
        out[q] = '-';
      }
      return false
    },
    ainvalid: function () {
      var out = ['A0', 'A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'A9', 'A10', 'A11', 'A12', 'A13', 'A14', 'A15'];
      // console.log(this.dassign[0].rom, out)
      for (let i = 0; i < 8; i++) {
        let d = this.alassign[i].rom;
        let q = out.indexOf(d)
        if (q < 0) return true;
        out[q] = '-';
      }
      for (let i = 0; i < 8; i++) {
        let d = this.ahassign[i].rom;
        let q = out.indexOf(d)
        if (q < 0) return true;
        out[q] = '-';
      }
      return false
    },
    textout: {
      get () {
        var ln = this.text.split('\n')
        var out = '';
        if (this.dinvalid) return '***INVALID DATA SCRAMBLING***'
        if (this.ainvalid) return '***INVALID ADDRESS SCRAMBLING***'
        // var org = null;
        var dass = this.dassign.map(function (q) { return parseInt(q.rom[1]); });
        console.log(dass)
        for (var i = 0; i < ln.length; i++) {
          let l = ln[i];

          let h = hexLine(l);
          console.log(h)
          if (h && h.typ === 0) {
            let data = h.data.map(function (n) { return scramble(n, dass) })
            console.log(data)
            h.data = data
            out += genHex(h) + '\n'
          } else {
            out += (l + '\n')
          }
        }

        return out;
      },
      set () { return }
    }
  },
  mounted () {
    doDrag(this)
  }
}

/*
:200000002DC655C533CAFFC616C9F4CC42C9ACC7ACC684C62FC719C68FC6D9C642C72BC675
:2000200052C76EC625D474FF75FFD1CF1CD422C854C6B4C47FC660C4CCD756D8E9D70A0083
:20004000A1CFC2CFA0DAB4DBB1D50FDBF0DBF7DB40DC8DDC12D480D380D0B1D38FD3F0D2D3
:00000001FF
*/
</script>

<style>
textarea {font-family: monospace !important;}
</style>
